/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import types from "./types";

export const isAdministrator = (roles) =>
  roles.includes(types.goTrackUserRoles.administrator);

export const isCarrier = (roles) =>
  roles.includes(types.goTrackUserRoles.carrier);

export const isShipper = (roles) =>
  roles.includes(types.goTrackUserRoles.shipper);

export const isShipperManager = (roles) =>
  roles.includes(types.goTrackUserRoles.shipperManager);
